(function() {
  const cart = JSON.parse($('#affiliateCartJSON').html());
  function updateCartAttribute(affCode) {
    console.log(cart.attributes['_affiliateCode'])
    if (cart.attributes['_affiliateCode'] !== affCode) {
      const data = {
        attributes: {
          '_affiliateCode': affCode
        }
      }
      axios.post('/cart/update.js', data).then(response => console.log(response))
    }
  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // get affiliate code from query 
  const urlParams = new URLSearchParams(window.location.search);
  const affiliateCodeInUrl = urlParams.get('affiliateCode');

  // get affiliate code from cookie
  const affiliateCodeCookie = getCookie('affiliateCode');    
  // 
  if (affiliateCodeCookie) {
    fetch('https://burkedecor-affiliate-listener.aiva-apps.com/pageview?loc=' + window.location.href + '&affiliateCode=' + affiliateCodeCookie);
    updateCartAttribute(affiliateCodeCookie)
  } else {
    if (affiliateCodeInUrl) {
      setCookie('affiliateCode', affiliateCodeInUrl, 7)  
      fetch('https://burkedecor-affiliate-listener.aiva-apps.com/pageview?loc=' + window.location.href + '&affiliateCode=' + affiliateCodeInUrl);
      updateCartAttribute(affiliateCodeInUrl)
    }
  }
})();


document.addEventListener('DOMContentLoaded', function() {
  $(document).on('click', '.ssw-fave-action', function() {
    const shareElements = $('.ssw-faves-share-bar').html()
    if (!$('.ssw-modal-body').find('.ssw-faves-share-bar').length) {
      $('.ssw-modal-body').append('<div class="ssw-faves-share-bar" style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">' + shareElements + '</div>')
    }
  });


  //acsbapp.com
  (function(){ var s = document.createElement('script'), e = ! document.body ? document.querySelector('head') : document.body; s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; s.async = true; s.onload = function(){ acsbJS.init({ statementLink : '', footerHtml : '', hideMobile : false, hideTrigger : false, language : 'en', position : 'left', leadColor : '#000000', triggerColor : '#000000', triggerRadius : '50%', triggerPositionX : 'left', triggerPositionY : 'bottom', triggerIcon : 'people', triggerSize : 'medium', triggerOffsetX : 20, triggerOffsetY : 20, mobile : { triggerSize : 'small', triggerPositionX : 'left', triggerPositionY : 'bottom', triggerOffsetX : 10, triggerOffsetY : 10, triggerRadius : '50%' } }); }; e.appendChild(s);}());
});